import React from 'react';
import * as S from '@/components/Ad/FloatingButtons/FloatingButtons.styles';
import { ChatButton } from '@/components/Ad/ChatButton/ChatButton';
import { CallButton } from '@/components/Ad/CallButton/CallButton';

export const FloatingButtons = () => {
  return (
    <S.Box>
      <CallButton dataTestId="floating-call-button" />
      <ChatButton />
    </S.Box>
  );
};
